import React, { useEffect, useRef, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Toolbar } from 'primereact/toolbar';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { InputText } from 'primereact/inputtext';
import Menu from '../../components/sturtural/Menu';
import { Dropdown } from 'primereact/dropdown'
import TransaccionTablet from '../../components/dialogs/TransaccionTablet';
import { BASE_API, LABELTEXT } from '../../api/Globals';
import { helpHttp } from '../../helpers/helpHttp';
import { FilterMatchMode } from 'primereact/api'
import FolioConsulta from '../../components/dialogs/FolioConsulta';
import RegistrarTableta from '../../components/dialogs/RegistroTableta';
import { useLoaderData } from 'react-router-dom';
import classNames from 'classnames';
import { storage } from '../../helpers/storage';

const SalidaTablets = () => {
    const [tablets, setTablets] = useState(null);
    const [registroDialog, setRegistroDialog] = useState(false);
    const [TransaccionDialog, setTransaccionDialog] = useState(false)
    const [folioData, setFolioData] = useState([])
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })
    const [status, setStatus] = useState(null)
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [loading1, setLoading1] = useState(false)
    const toast = useRef(null)

    useEffect(() => {
        if (tablets === null) {
            setLoading1(true)
            const url = (`${BASE_API}Tablets/postSpdAlmObtenerlistadoTabletsFolioMov`)
            helpHttp().post(url, {
                body: {
                    idUsuario: storage.get('id'),
                    idEstatus: storage.get('perfilid') !== '14' ? 6 : 2,
                    idTienda: null,
                    idAlmacen: null,
                    parametrosExtra: "S"
                },
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${storage.get('token')}`
                }
            }).then(res => {
                setLoading1(false)
                setTablets(res.ITEMS)
            })
        }
    }, [tablets]);

    const rightToolbarTemplate = () => {
        return (
            // <React.Fragment>
            <div className='justify-content-end grid'>
                <div className='col-12 md:col-4 lg:col-4'>
                    <Button label="Enviar" icon="pi pi-minus" className="p-button " onClick={() => {setLoading1(true); setTransaccionDialog(true); setStatus(3) }} />
                </div>
                <div className='col-12 md:col-4 lg:col-4'>
                    <Button label="Transferir" icon="pi pi-minus" className="p-button " style={{marginLeft: '-9px'}} onClick={() => { setTransaccionDialog(true); setStatus(6) }} />
                </div>
                <div className='col-12 md:col-4 lg:col-4'>
                    <Button label="Devolver" icon="pi pi-minus" className="p-button" onClick={() => { setTransaccionDialog(true); setStatus(7) }} />
                </div>
            </div>
            // </React.Fragment>
        )
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className='w-20rem lg:w-30rem md: w-20rem' value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Buscador por destino" />
                </span>
        );
    };

    const icon = (rowData) => {
        return <Button icon='pi pi-ellipsis-h' rounded text onClick={() => setFolioData(rowData)} />
    }

    const DateFormatTemplate = (options) => {
        const date = new Date(options.Fecha)

        return <div className='text-center'><label>{date.toLocaleDateString('em-GB')}</label></div>
    }

    return (
        <>
            <Toast ref={toast} />
            <Menu link='filtro' />
            <div className='grid card'>
                <h3 style={{ textAlign: 'center' }}>GESTIÓN DE SALIDAS</h3>
                <div className='col-12'>
                    <Toolbar id='almacen-salida' left={renderHeader} right={rightToolbarTemplate} />
                </div>
                <div className='col-12 p-4'>
                    <DataTable value={tablets} showGridlines loading={loading1}
                        filters={filters} globalFilterFields={['FolioTransferencia', 'TIenda_Destino']}
                        paginator rows={20} paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        currentPageReportTemplate="Mostrando del {first} al {last} de {totalRecords} folios." emptyMessage="Sin folios registrados.">
                        <Column field='FolioTransferencia' header='Folio' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        <Column field='TIenda_Destino' header='Destino' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        <Column field='Estatus' header='Estatus' bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                        <Column field='totalTablet' header={`Total de ${LABELTEXT.toLowerCase()}`} bodyStyle={{ textAlign: 'center' }} headerStyle={{ width: '124px' }} alignHeader={'center'} />
                        <Column field='Fecha' body={DateFormatTemplate} header='Fecha último registro' alignHeader={'center'} />
                        <Column header='Detalle' body={icon} bodyStyle={{ textAlign: 'center' }} alignHeader={'center'} />
                    </DataTable>
                    <h5>Total de folios: {tablets !== null ? tablets.length : 0}</h5>
                </div>
            </div>

            <TransaccionTablet visible={TransaccionDialog} status={status} loading={() => loading1} onHide={() => { setTransaccionDialog(!TransaccionDialog); setTablets(null) }} abrirAlta={(e) => { setRegistroDialog(!registroDialog); }} />
            <RegistrarTableta visible={registroDialog} onHide={() => { setRegistroDialog(!registroDialog) }} />
            <FolioConsulta rowData={folioData} onHide={() => { setFolioData([]); setTablets(null) }} />
        </>
    );
}

export default SalidaTablets;